import gql from 'graphql-tag';
import { getGraphQLClientForVendorLibraryWithToken } from 'utils/apiRequests';
import { formatSpendWithDecimalAndSymbol } from 'utils/number';

//Below two are helper functions for fieldname errors for graphql 2.4.0
function lowercaseFirstChar(obj) {
	const newObj = {};
	for (let key in obj) {
		if (obj.hasOwnProperty(key)) {
			const value = obj[key];
			const newKey = key.charAt(0).toLowerCase() + key.slice(1);
			if (typeof value === 'object' && !Array.isArray(value)) {
				// Recursively lowercase first character of field names of nested objects
				newObj[newKey] = lowercaseFirstChar(value);
			} else {
				newObj[newKey] = value;
			}
		}
	}

	// Remove the "filterTo" and "dateTo" property if it exists
	delete newObj.filterTo;
	delete newObj.dateTo;

	return newObj;
}

function capitalizeFieldNames(arr, hideDecimals) {
	// Iterate over each object in the array
	return arr.map(obj => {
		const newObj = {};
		// Iterate over each key in the object
		for (let key in obj) {
			if (obj.hasOwnProperty(key)) {
				// Check if the key contains "custom_data"
				if (
					key === 'pO_BASE_SPEND' ||
					key === 'nET_VALUE_BASE_GBP' ||
					key === 'nET_VALUE_BASE_USD' ||
					key === 'nET_VALUE_BASE_EUR' ||
					key === 'spend'
				) {
					const capitalizedKey = key.charAt(0).toUpperCase() + key.slice(1);
					newObj[capitalizedKey] = formatSpendWithDecimalAndSymbol(
						obj[key],
						'$',
						hideDecimals,
						2
					).toUpperCase();
				} else if (key.includes('custom_data')) {
					newObj[key] = obj[key]; // No capitalization for "custom_data" keys
				} else if (key.endsWith('_count')) {
					const newKey = key.slice(0, -6); // Remove the '_count' suffix
					const capitalizedKey =
						newKey.charAt(0).toUpperCase() + newKey.slice(1);
					newObj[capitalizedKey] = obj[key];
				} else {
					// Capitalize the first letter of the key
					if (key === 'sOURCEABLE') {
						// Capitalize the first letter of the key
						const capitalizedKey = key.charAt(0).toUpperCase() + key.slice(1);
						// Assign the value to the new capitalized key
						if (obj[key] === true) {
							newObj[capitalizedKey] = 'true';
						} else if (obj[key] === false) {
							newObj[capitalizedKey] = 'false';
						} else {
							newObj[capitalizedKey] = null;
						}
					} else if (key === 'updated_at' || key === 'created_at') {
						// Capitalize the first letter of the key
						const capitalizedKey = key.charAt(0).toUpperCase() + key.slice(1);
						// Assign the value to the new capitalized key
						const formattedDate = new Date(obj[key]).toLocaleDateString(
							'en-GB',
							{ day: '2-digit', month: '2-digit', year: 'numeric' }
						);
						newObj[capitalizedKey] = formattedDate;
					} else {
						const capitalizedKey = key.charAt(0).toUpperCase() + key.slice(1);
						// Assign the value to the new capitalized key
						newObj[capitalizedKey] = obj[key];
					}
				}
			}
		}
		return newObj;
	});
}

const vendorNormailaiztionquery = (request, columns) => {
	// const fields=columns.map(col=>col.fields);

	const nestedCols = columns
		.filter(col => col.children)
		.map(childrenfields => childrenfields.children)
		.flat()
		.map(col => `${col.field?.charAt(0).toLowerCase()}${col.field?.slice(1)}`);
	const normalcols = columns
		.map(col => `${col.field?.charAt(0).toLowerCase()}${col.field?.slice(1)}`)
		.filter(el => el !== 'undefinedundefined')
		.filter(el => el !== 'pO_ID_AP');
	const fields = normalcols.concat(nestedCols);
	return {
		query: gql`
      query aPVendorData(
          $start: Int!, 
          $end: Int!, 
          $sortModel: [SortModelType!], 
          $filterModel:[FilterModelType!],
		  $groupKeys: [String!],
          $rowGroups:[RowGroupModelType!],
		  $valueCols:[ValueColsModelType!],
		  $havingModel:[HavingModelType!],
		  
        ) {
			aPVendorData(
          startRow: $start,    
          endRow: $end,
          sorting: $sortModel,
          filterModel:$filterModel,
		  groupKeys: $groupKeys,  
          rowGroups:$rowGroups,
		  valueCols:$valueCols,
		  havingModel:$havingModel
        ) {
        ${[...fields]}
        }
      }
    `,
		variables: {
			start: request.startRow,
			end: request.endRow,
			sortModel: request.sortModel,
			filterModel: [lowercaseFirstChar(request.filterModel)],
			rowGroups: [],
			valueCols: [],
			groupKeys: [],
			havingModel: [],
		},
	};
};
//this function makes columns from the data

const createDatasource = (gridOptions, columnApi, api, hideDecimals) => {
	return {
		// called by the grid when more rows are required
		getRows: async params => {
			const object = {};
			object.gridOptions = gridOptions;
			object.client = await getGraphQLClientForVendorLibraryWithToken();
			const columns = object.gridOptions.columnDefs;

			object.client
				.query(vendorNormailaiztionquery(params.request, columns))
				.then(response => {
					let rows = capitalizeFieldNames(
						response.data.aPVendorData,
						hideDecimals
					);
					let lastRow = -1;
					if (rows.length <= gridOptions.cacheBlockSize) {
						lastRow = params.request.startRow + rows.length;
					}
					params.successCallback(rows, lastRow);
				})
				.catch(err => {
					console.error(err);
					params.failCallback();
				});
		},
	};
};

export default createDatasource;
